import React, { useContext } from 'react'
import { Typography, Grid, Container } from '@material-ui/core';
import '../EndOfFlowPage.scss'
import { useEffect } from 'react';
import summaryApi from '../../../api/summary.api';
import { SessionContextStore } from '../../../context/SessionContext/SessionContext';
import { useHistory } from "react-router-dom"
import { AlertContextStore } from '../../../context/AlertContext/AlertContext';
import { QuoteContextStore } from '../../../context/QuoteContext/QuoteContext';
import { awaitWithLoading } from '../../../services/utils';
import { QUOTE_STATUS } from '../../../context/QuoteContext/types';


const UnderwritterRefferal = () => { 
    const { liabilityQuote, loadQuote, deleteLiabilityQuote, liabilityQuoteStatus } = useContext(QuoteContextStore);

    const { showInfo } = useContext(AlertContextStore);
    const history = useHistory();

    useEffect(() => {
        if(liabilityQuote !== null && liabilityQuoteStatus === QUOTE_STATUS.QUOTED ){
            showInfo({
                title: "Quote in Underwriter Review",
                message: "Your original quote is still under review. In the meantime, we can offer you a liability-only quote.",
                confirmButtonText: "View Liability Only Quote",
                cancelButtonText: "No, Thanks",
                onConfirm: async () => {
                    const resLoad = await awaitWithLoading(loadQuote(liabilityQuote, false))
                        if(resLoad === true ){
                            history.replace('/insurance/coverages' + `/${liabilityQuote}`);
                        }
                },
                onCancel: async () => {
                    await awaitWithLoading(deleteLiabilityQuote(liabilityQuote))
                },
            });
        }
    }, [liabilityQuote, liabilityQuoteStatus])
    
    return (
            <div>
                <Typography class="congrats-main-title"><span className='super-light-blue margin-bottom-large'>Underwriter approval <br/> required</span></Typography>
                <Typography className='white bold'>Your policy is under review</Typography>
                <br/>
                <Typography variant='body1' className='white'>Our underwriters are checking your information, <br/>we will contact you as soon as we finish.</Typography>
                <Typography variant='body1' className='white margin-bottom-medium'>If you have any questions feel free to call our support team <br/>888-364-5033</Typography>
            </div>
    )

}

export default UnderwritterRefferal